import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { IReportPeriod } from 'partner360/models/report/iReportPeriod'

import { PeriodsOption } from './components/periodsOption/PeriodsOption'
import { IReportViewSelectorProps } from './models/iReportViewSelectorProps'
import { ReportViewModes } from './models/reportViewModes'
import { TRANSLATION_KEYS } from './translations'

import styles from './ReportViewSelector.module.scss'

export const ReportViewSelector: FC<IReportViewSelectorProps> = ({
  reportViewMode,
  selectedReportViewPeriod,
  reportViewPeriodsOptions,
  onChangeReportViewState,
}) => {
  const handleSelectView = useCallback(
    (viewMode: ReportViewModes) => {
      return (selectedPeriod?: IReportPeriod) => {
        onChangeReportViewState(viewMode, selectedPeriod)
      }
    },
    [onChangeReportViewState]
  )

  return (
    <div className={styles.root}>
      <div className={styles.label}>
        <Translation text={TRANSLATION_KEYS.title} />
      </div>
      <div className={styles.buttonsContainer}>
        <PeriodsOption
          titleKey={TRANSLATION_KEYS.quarterlyView}
          isSelected={reportViewMode === ReportViewModes.QuarterlyView}
          selectedValue={selectedReportViewPeriod}
          options={reportViewPeriodsOptions}
          onSelectReportPeriod={handleSelectView(ReportViewModes.QuarterlyView)}
        />
        <PeriodsOption
          titleKey={TRANSLATION_KEYS.trendView}
          isSelected={reportViewMode === ReportViewModes.TrendView}
          selectedValue={selectedReportViewPeriod}
          options={reportViewPeriodsOptions}
          onSelectReportPeriod={handleSelectView(ReportViewModes.TrendView)}
        />
        <PeriodsOption
          titleKey={TRANSLATION_KEYS.partnerView}
          isSelected={reportViewMode === ReportViewModes.PartnerView}
          selectedValue={selectedReportViewPeriod}
          options={reportViewPeriodsOptions}
          onSelectReportPeriod={handleSelectView(ReportViewModes.PartnerView)}
        />
      </div>
    </div>
  )
}
